import { useLazyQuery, useQuery } from "@apollo/client";
import { QR_CODES } from "../qr-code.queries";
import { QrCodesQuery, QrCodesQueryVariables } from "../../../__generated__/QrCodesQuery";

export const useQrCodes = (variables: QrCodesQueryVariables) => {
  return useQuery<QrCodesQuery, QrCodesQueryVariables>(QR_CODES, { variables });
};

export const useLazyQrCodes = () => {
  return useLazyQuery<QrCodesQuery, QrCodesQueryVariables>(QR_CODES);
};
